import React, { useState } from 'react';
import Lightbox from 'react-image-lightbox'; // Use a lightbox library
import 'react-image-lightbox/style.css'; // Import CSS for the lightbox

const PortfolioSection = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const images = [
    "/images/gallery/1.jpg",
    "/images/gallery/2.jpg",
    "/images/gallery/3.jpg",
    "/images/gallery/4.jpg",
    "/images/gallery/5.jpg",
    // "/images/gallery/6.jpg",
    // "/images/gallery/7.jpg",
    // "/images/gallery/8.jpg",
    // "/images/gallery/9.jpg",
    "/images/gallery/10.jpeg",
    "/images/gallery/11.jpeg",
    "/images/gallery/12.jpeg",
    "/images/gallery/13.jpeg",
    "/images/gallery/14.jpeg",
    "/images/gallery/15.jpeg",
    "/images/gallery/16.jpeg",
    "/images/gallery/17.jpeg",
    "/images/gallery/18.jpeg",
  
  
  ];

  const vehicleNames = [
     "SWIFT DZIRE",
      "ERTIGA",
    "INNOVA CRYSTA",
    "TEMPO TRAVELLER",
    "TEMPO TRAVELLER",
   
    
  ];

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setIsOpen(true);
  };

  const closeLightbox = () => {
    setIsOpen(false);
  };

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <div>
    
     <div
      className="breadcumb-wrapper"
      // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
    >
      <div className="container z-index-common">
        <div className="breadcumb-content">
          <h1 className="breadcumb-title">Gallery</h1>
          <div className="breadcumb-menu-wrap">
          </div>
        </div>
      </div>
    </div>


      <div className="section-full site-bg-white p-t150 p-b120 twm-portfolio-wrap wow fadeInDown" data-wow-offset="100" data-wow-delay="0.2">
        <div className="container">
          <ul className="masonry-outer mfp-gallery work-grid row clearfix list-unstyled m-b0">
            {images.map((image, index) => (
            












<li key={index} className={`masonry-item cat-${(index % 4) + 1} col-lg-4 col-md-6 m-b30`}>
  <div className="gallery-card">
    <a className="gallery-link" href="#" onClick={() => openLightbox(index)}>
      <div className="gallery-img">
        <img src={image} alt={vehicleNames[index]} />
        <div className="gallery-overlay">
          <span className="icon-view"><i className="feather feather-maximize"></i></span>
        </div>
      </div>
    </a>
    <div className="gallery-info">
      <h3 className="gallery-title">{vehicleNames[index]}</h3>
    </div>

 
  </div>
</li>



            ))}
          </ul>

          {/* Lightbox Modal */}
          {isOpen && (
            <Lightbox
              mainSrc={images[currentImageIndex]}
              nextSrc={images[(currentImageIndex + 1) % images.length]}
              prevSrc={images[(currentImageIndex - 1 + images.length) % images.length]}
              onCloseRequest={closeLightbox}
              onMovePrevRequest={prevImage}
              onMoveNextRequest={nextImage}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PortfolioSection;
